import React from 'react';
import { Message } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const RequestConfirmationDelayed = () => {
  const intl = useIntl();
  return (
    <Message
      className="aridhia-request-confirmation-delayed"
      size="small"
      icon="wait"
      header={intl.formatMessage({ id: 'access.request.delayed.title' })}
      content={intl.formatMessage({ id: 'access.request.delayed' })}
    />
  );
};

export default RequestConfirmationDelayed;
